"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = onPlaying;
function onPlaying(event) {
  clearTimeout(this._bufferTimeout);
  if (this.logger.times.BufferTime > 0) {
    this.logger.logTime('BufferTime', performance.now() - this.logger.times.BufferTime);
  }
  this._emitTimeUpdate();

  // Clear BufferTime after Load or Buffer log
  this.logger.times.BufferTime = 0;
  this.emit('playing', event);
}